import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store/index'

import  commFunc from './utils/common'
import reqApi from "./utils/reqApi"; //加载全局api函数

import { Card, Timeline, TimelineItem } from 'element-ui'

import navBar from './components/nav.vue'

Vue.use(Card)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.component('navBar', navBar)

Vue.prototype.commFunc = commFunc; //公共函数
Vue.prototype.reqApi = reqApi; //配置全局业务处理函数

Vue.config.productionTip = false

router.beforeEach((to,from,next) => {
    commFunc.siteInfo(null,(res)=>{
        console.log(res)
        next();
    },(err)=>{
        //业务错误返回
        console.log(err)
    })
})

new Vue({
    router, store, render: (h) => h(App)
}).$mount('#app')

// title

// title
